import RsvpsExtendedListViewCtrl from '../../../../../store/rsvps/controllers/extended-list-view';

angular
    .module('festzelt-os.guestlists')
    .controller('RsvpsExtendedListViewCtrl', [
        'Rsvp',
        '$injector',
        '$scope',
        (Rsvp, $injector, $scope) => new RsvpsExtendedListViewCtrl(Rsvp, $injector, $scope)
    ]);



// WEBPACK FOOTER //
// ./src/app/pages/guestlists/controllers/rsvps/store/extended-listview.js